'use strict';

function LinkToLoanBank() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _BankController];
  this._history = new History();
  this._LOAN_DASHBOARD_PATH = '/member/dashboard/loans';

  this._DEBUG = false;
  if (this._DEBUG) this.pageName = '[LinkToLoanBank]';

  this.init = function () {
    this._super();
    this._$notification = $('#Notification');
    this._$longWaitingMsg = $('.js--long-waiting-message');
  };

  this.initAllReady = function () {
    this._super();

    // Update PlaidErrorHandler configs
    this.updateErrorConfigs({
      initErrorPage: false
    });
  };

  this.initPage = function () {
    var _this = this;

    if (this._DEBUG) console.log(this.pageName + ' Called');

    // Cache vars
    this._$exitVerifyDialog = $('.js--exit-verify-dialog');
    this._$exitDialogCta = $('.js--exit-dialog-cta');
    this._$cancelDialogCta = $('.js--cancel-dialog-cta');
    this._$spinner = $('.js--loading-spinner');
    this._acct = null;

    if (this.presenter.models.bankSelected) {
      if (this._DEBUG) console.log(this.pageName + ' - this.presenter.models.bankSelected is true');

      // Linking account means to successfully creating a bank_account associated with given member
      this.createBankAccount(null, function (newAcct) {
        // define Success Callback for linkAccount method
        var onLinkAccountSuccess = function onLinkAccountSuccess(bk) {
          var _bankName = this.presenter.getModelProperty('bankSelected.name');
          this.analytics.pushEvent('abl-success', { ABLBank: [_bankName] });
          this._$longWaitingMsg.show();
          this._$spinner.show();
          this._associateAndVerify(newAcct, this._onSuccess.bind(this), this._onFailure.bind(this));
        };
        // Pass in Success Callback into linkAccount Method
        _this._acct = newAcct;
        _this._$spinner.hide();
        if (!newAcct.isLinked()) {
          newAcct.linkAccount(onLinkAccountSuccess.bind(_this), _this._onFailure.bind(_this));
        } else {
          onLinkAccountSuccess.bind(_this);
        }
      });
    } else {
      if (this._DEBUG) console.log(this.pageName + ' - this.presenter.models.bankSelected is false, bank not selected');
      location.replace('/member/dashboard/loans/apply');
      return;
    }

    var bvStatus = this._getBankVerificationStatus();
    if (bvStatus) bvStatus = bvStatus.status;
    var bvSubmitted = bvStatus === 'submitted' || bvStatus === 'failed' || bvStatus === 'verified';
    if (bvSubmitted) {
      if (this._DEBUG) console.log(this.pageName + ' - ABV has already been attempted, and the status is submitted || failed || verified, redirecting ...\'');
      // do not allow user to verify bank here if they have already attempted to do so
      window.location.replace('/portal/dashboard?arn=true');
      return;
    }
    this._$exitDialogCta.on('click', function () {
      _this._$exitVerifyDialog.mogo().show();
    });
    this._$cancelDialogCta.on('click', function (event) {
      $(event.currentTarget).closest('[data-mogo-ui="Dialog"]').mogo().hide();
    });
    this.analytics.pushEvent('virtual-page-view');
  };

  this.destroy = function () {
    if (!this._$exitVerifyDialog.mogo().create) {
      this._$exitVerifyDialog.mogo().destroy();
    }
  };

  this._onSuccess = function (data) {
    var _this2 = this;

    if (this._DEBUG) console.log(this.pageName + ' - _onSuccess() Callback called\'');

    this.getBankAccountById(this._acct.id, function (acct) {
      _this2._acct = acct;
      _this2.getBankById(_this2._acct.bankId, function (bk) {
        _this2._$spinner.hide();
        _this2.analytics.pushEvent('abs-status', { ABSBank: [bk.getBankName()] });
        location.replace('/member/dashboard/loans/apply');
      });
    });
  };

  this._onFailure = function (errorData, response) {
    if (this._DEBUG) {
      console.log(this.pageName + ' - _onFailure() Callback called: ' + JSON.stringify(errorData));
    }

    if (errorData.errors) {
      this.analytics.forcePushEvent('generic-api-response-error', {
        event: ['PlaidBankLinkOrVerifyResponse'],
        Code: [errorData.errors[0].code],
        Key: [errorData.errors[0].key],
        Msg: [errorData.errors[0].msg],
        Property: [errorData.errors[0].property]
      });
    }
    this._$spinner.hide();
    if (errorData && errorData.errors && (errorData.errors[0].key === 'client_polling_timeout_client' || errorData.errors[0].key === 'rpc_timeout')) {
      this._$notification.mogo().create({
        isPersistent: true,
        msg: 'Hmm, we seem to be having an issue checking bank connections right now. Please try again later.',
        type: 'error'
      });
      this.analytics.forcePushEvent('link-bank-status', { LinkBankStatus: ['Bank Link Timeout'] });
      this._history.goToUrl(this._LOAN_DASHBOARD_PATH);
    } else if (errorData && !errorData.hasOwnProperty('result')) {
      /*
            Result property is ONLY present during ABV process below
            At this point there will never be a result property. 
             User saw error in Plaid Iframe , closed it / went back manually
            In this case - Go back to the Verify bank screen 
        */
      this._history.replaceUrl('/member/dashboard/loans/apply/bank-statement/verify');
    } else {
      /*
        In this case, ABS (Bank Submission) was successful, 
        The logic below is for the next step after this - ABV (Bank Verification)
        In all cases below, Result property is present on the errorData object
      */
      var _bankName = this.presenter.getModelProperty('bankSelected.name');

      // errorData result can be false or null!
      if (errorData.result === false) {
        if (this._DEBUG) console.log(this.pageName + ' - ABS Success, ABV Failed\'');

        // ABS came back successfully, but the user didn't pass verification.
        // redirect user to FS portal dashboard.
        this.analytics.pushEvent('abs-status', {
          Status: ['failed'],
          ABSBank: [_bankName]
        });

        location.replace('/portal/dashboard');
      } else {
        // Result Null, show them the dlt error page
        this.analytics.pushEvent('abs-status', {
          Status: ['null'],
          ABSBank: [_bankName]
        });
        if (this._DEBUG) console.log(this.pageName + ' - ABS SUCCESS, ABV Failed - Try again, show error screen\'');

        // Use replaceUrl so the history is not saved.
        // Users will not be able to go back Bank In Progress
        this._history.replaceUrl('/member/dashboard/loans/apply/bank-statement/dlt-fallback-error');
      }
    }
  };

  this._associateAndVerify = function (acctObj, onSuccess, onFailure) {
    var onAssociateWithProductSuccess = function onAssociateWithProductSuccess() {
      acctObj.verifyBankStatus(onSuccess.bind(this), onFailure.bind(this));
    };

    if (acctObj.getAssociatedProducts() != BankAccount.productType.loan) {
      acctObj.associateWithProduct(BankAccount.productType.loan, onAssociateWithProductSuccess.bind(this), onFailure.bind(this));
    } else {
      onAssociateWithProductSuccess.bind(this);
    }
  };
}